export default __webpack_public_path__ + "static/media/hht2_ep06_timeline_q03_a.8322d4dc.png";